import { render, staticRenderFns } from "./relevant.vue?vue&type=template&id=2362bf96&scoped=true&"
import script from "./relevant.vue?vue&type=script&lang=js&"
export * from "./relevant.vue?vue&type=script&lang=js&"
import style0 from "./relevant.vue?vue&type=style&index=0&id=2362bf96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2362bf96",
  null
  
)

export default component.exports